export default "__VITE_ASSET__DMAns116__"